import { GooglePayData } from '../types/googlePayData.types';

export function mapAllowedPaymentMethods(
  allowedPaymentMethods: GooglePayData['allowed_payment_methods'] = []
) {
  return allowedPaymentMethods.map((method) => ({
    type: method.type,
    parameters: {
      allowedAuthMethods: method.parameters.allowed_auth_methods,
      allowedCardNetworks: method.parameters.allowed_card_networks,
      billingAddressRequired: true,
      billingAddressParameters: {
        format: 'FULL',
        phoneNumberRequired: true,
      },
    },
    tokenizationSpecification: {
      type: method.tokenization_specification.type,
      parameters: {
        gateway: method.tokenization_specification.parameters.gateway,
        gatewayMerchantId:
          method.tokenization_specification.parameters.gateway_merchant_id,
      },
    },
  }));
}
